/**
 * Una sola configuracion de Google Maps para todo el sistema.
 *
 * La libreria @react-google-maps/api carga el script de Google una vez por sesion y la PRIMERA pantalla que lo
 * pide fija las opciones: si otra pantalla lo pide despues con otro id, otras librerias u otra clave, esa pantalla
 * se cae con "Loader must not be called again with different options". Por eso todas las pantallas usan estas
 * mismas opciones (incluye 'places', que necesita el buscador de direcciones de Siniestros).
 * El arreglo de librerias es una constante del modulo: si se crea en cada render, la libreria vuelve a cargar.
 */
export const GOOGLE_MAPS_API_KEY = 'AIzaSyAZNnAAUdLjXR2GGOkyBABC1ch4_o38i2U';

const LIBRERIAS = ['places'];

export const OPCIONES_GOOGLE_MAPS = {
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: LIBRERIAS
};
